import { useEffect } from "react";

/**
 * Tattoo machine cursor — visual only, no ink trails
 * Desktop only — hidden on touch devices
 */
export const TattooInkCursor = () => {
  useEffect(() => {
    // Skip on touch devices
    if ("ontouchstart" in window) return;

    // Add custom cursor class to body for CSS cursor styling
    document.body.classList.add("tattoo-cursor");

    return () => {
      document.body.classList.remove("tattoo-cursor");
    };
  }, []);

  // Don't render anything on touch devices
  if (typeof window !== "undefined" && "ontouchstart" in window) return null;

  // No canvas, no visual element — cursor is styled via CSS
  return null;
};

export default TattooInkCursor;
